import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { PDFDocument } from 'pdf-lib';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Input, Modal } from 'components';
import { CleanIcon, ViewIcon, Menu as MenuIcons, AddIcon } from 'assets/icons';
import { SignatureService, StorageService, GeneralService } from 'services';
import moment from 'moment';
import { WhiteImage } from 'assets/img';
import { useApacuana } from 'contexts/ApacuanaContext';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  onClose?: any;
  item?: any;
  setLoading?: any;
  addSigner?: any;
  getDocs?: any;
  signDocument?: any;
  isExistCertificate?: any;
  password?: any;
  file?: any;
  apacuana?: any;
  sendResponse?: any;
  openGenerateForm?: any;
  setOpenGenerateForm?: any;
}

const TABS = {
  MINE: 'mine',
  PENDING: 'pending',
};

const INITIAL_STATE = {
  search: '',
  status: '',
};

class Signatures extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['', '', ''],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    plan_user: undefined,
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    price: 0,
    active_tab: TABS.MINE,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Firma Electrónica',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await SignatureService.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      user_id: this.props.user?.id,
    });
    const selects: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      service_id: Constants.SERVICES.SIGN,
    });
    this.setState({
      data: res.signatures.rows,
      last_page: res.signatures.count,
      plan_user: res.plan_user,
      membership_status: res.membership_status,
      price: selects.services[0].price,
    });
  };

  // Abre el modal de "crear solicitud de firma" (mismo flujo que el cliente:
  // subir documento + invitar firmantes por código, opcionalmente firmar ya).
  add = () => {
    this.setState({ visible: true });
  };

  onClose = () => {
    this.setState({ visible: false }, () => this.load(true));
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.SIGNATURE_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.SIGNATURE_STATUS.ACCEPTED:
        return Colors.green;
        break;

      case Constants.SIGNATURE_STATUS.REJECTED:
        return Colors.danger;
        break;
    }
  };

  sendResponse = async (item: any, file: any) => {
    await SignatureService.saveResponse({
      file,
      signature_id: item.id,
      hasFile: true,
    });
    Globals.showSuccess('Se ha enviado el archivo correctamente');
    this.load(true);
  };

  openFile = async (key: string) => {
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
  };

  render() {
    const { visible, active_tab } = this.state;
    const plan_user: any = this.state.plan_user;

    return (
      <div id='lawyer-signature'>
        <div className='row row-tabs'>
          <div className='col-md-4' style={{ padding: '8px' }}>
            <button
              className={`btn ${active_tab == TABS.MINE ? 'active' : 'inactive'}`}
              onClick={() => this.setState({ active_tab: TABS.MINE })}
            >
              Mis firmas
            </button>
          </div>
          <div className='col-md-4' style={{ padding: '8px' }}>
            <button
              className={`btn ${active_tab == TABS.PENDING ? 'active' : 'inactive'}`}
              onClick={() => this.setState({ active_tab: TABS.PENDING })}
            >
              Solicitudes de firma
            </button>
          </div>
        </div>

        <Modal
          className='modal-create-signature'
          visible={visible}
          title=''
          onClose={() => this.onClose()}
        >
          {/* @ts-ignore */}
          <ModalCreate item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        {active_tab === TABS.PENDING ? (
          <PendingSignatures user={this.props.user} />
        ) : plan_user === null ? (
          <div className='container-no-membership'>
            <p>Para continuar debe tener una membresía activa</p>
          </div>
        ) : (
          <>
            <div className='row row-filter'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <Input
                      value={this.state.form.search}
                      name='search'
                      label='Buscar'
                      placeholder='Buscar'
                      className='input-table'
                      onSubmit={() => this.load()}
                      onChange={(e: any) => {
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => this.load(true), 1000);
                        this.change(e);
                      }}
                    />
                  </div>
                  <div className='col-md-4'>
                    {this.state.form != INITIAL_STATE && (
                      <button className='btn btn-clean' onClick={() => this.reset()}>
                        <img src={CleanIcon} />
                      </button>
                    )}
                  </div>
                  {this.state.membership_status !== Constants.ACCES_STATUS.ACCESS_DENIED && (
                    <div className='col-md-4 text-right'>
                      <button className='container-add-table' onClick={() => this.add()}>
                        <img src={AddIcon} />
                        <p>Nuevo</p>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Table title='' data={this.state.data.length} header={this.state.header}>
              {this.state.data.map((i: any, index: number) => {
                return (
                  <tr key={index}>
                    <td style={{ width: '40%' }}>
                      <div className='container-date'>
                        <div className='date'>
                          <p>{moment(i.created_at).format('DD/MM/YYYY')}</p>
                        </div>
                        <div className='code'>
                          <p>ID {i.number}</p>
                        </div>
                      </div>
                      <p className='text-secondary' style={{ fontSize: 13, margin: 0 }}>
                        <strong>Participantes: </strong>
                        {(() => {
                          // Igual que en cliente: quien ve la tarjeta siempre es el dueño o el
                          // abogado asignado, así que no se excluye a nadie -- solo se deduplica.
                          const all = [i.user, ...(i.signers || []).map((s: any) => s.user)];
                          const seen = new Set<number>();
                          const participants = all.filter((u: any) => {
                            if (!u || seen.has(u.id)) return false;
                            seen.add(u.id);
                            return true;
                          });
                          return participants.length
                            ? participants
                                .map((p: any) => `${p.name || ''} ${p.lastname || ''}`.trim())
                                .join(', ')
                            : 'Sin otros participantes';
                        })()}
                      </p>
                    </td>
                    <td style={{ width: '25%', textAlign: 'center' }}>
                      <div
                        className='container-status'
                        style={{ backgroundColor: this.getColor(i) }}
                      >
                        <p>{i.status_text}</p>
                      </div>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <div className='container-files'>
                        <div>
                          <button
                            type='button'
                            className={`file ${i.file == null ? 'disabled' : ''}`}
                            disabled={!i.file}
                            onClick={() => i.file && this.openFile(i.file)}
                          >
                            <img src={ViewIcon} />
                            <div style={{ flex: 1 }}>
                              <p>Documento enviado</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.last_page}
              active={this.state.page}
              onChange={async (page: number) => {
                await this.setState({ page });
                this.load();
              }}
            />
          </>
        )}
      </div>
    );
  }
}

const SignaturesWithApacuana = (props: any) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const [isExist, setIsExist] = useState(false);
  const [password, setPassword] = useState('');
  const [openGenerateForm, setOpenGenerateForm] = useState(false);
  const [file, setFile] = useState<any>(null);
  const [state, setState] = useState<any>(null);
  const [user, setUser] = useState<any>(null);
  const [item, setItem] = useState<any>(null);

  const init = async () => {
    setLoading(true);
    try {
      if (apacuanaContext?.isInitialized) {
        const response = await apacuanaContext?.sdk?.isCertificateInDevice();
        setIsExist(response.data.isExist);
      }
    } catch (e) {
      console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  const addSigner = async (signerData: any) => {
    setLoading(true);
    try {
      const result = await apacuanaContext?.sdk?.addSigner(signerData);
      return result;
    } catch (e) {
      console.error('SDK ERROR: Fallo al ejecutar addSigner.', e);
      return null;
    }
  };

  const signDocument = async (data: any) => {
    try {
      const result = await apacuanaContext?.sdk?.signDocument(data);
      return result;
    } catch (e) {
      console.error('SDK ERROR: Fallo al ejecutar signDocument.', e);
      return null;
    }
  };

  const getDocs = async () => {
    try {
      const result = await apacuanaContext?.sdk?.getDocsByCustomer({
        page: 0,
        size: 1,
      });
      return result;
    } catch (e) {
      console.error('SDK ERROR: Fallo al ejecutar getDocs.', e);
      return null;
    }
  };

  const base64ToFile = (base64Data: string, filename: string, mimeType: string): File => {
    // 1. Eliminamos el prefijo (ej: "data:image/png;base64,") si existe
    const base64Content = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;

    // 2. Decodificamos la cadena limpia
    const byteCharacters = atob(base64Content);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    return new File([blob], filename, { type: mimeType });
  };

  const sendResponse = async (item: any, state: any, user: any) => {
    try {
      // 1. Validar que el archivo exista antes de procesar
      if (!file) {
        Globals.showError('No hay un archivo seleccionado.');
        return;
      }

      // --- PASO A: Añadir hoja en blanco al PDF ---
      const existingPdfBytes = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Añadimos la página al final
      pdfDoc.addPage();
      const pageCount = pdfDoc.getPageCount();
      const modifiedPdfBytes: any = await pdfDoc.save();

      // Creamos el nuevo archivo con la corrección de tipos (usando Blob)
      const modifiedFile = new File([new Blob([modifiedPdfBytes])], file.name || 'documento.pdf', {
        type: 'application/pdf',
      });

      const document = item.lawyer.full_document;

      // --- PASO B: Configurar la firma en la NUEVA página (pageCount) ---
      const signerData = {
        name: modifiedFile.name,
        reference: '',
        typedoc: document.split('-')[0],
        doc: document.split('-')[1],
        signature: [
          {
            page: pageCount, // <--- Apunta a la última página añadida
            x: 60 / 100,
            y: 80 / 100,
          },
        ],
        file: modifiedFile, // <--- Usamos el archivo modificado
      };

      await addSigner(signerData);

      const docToSignRes = await getDocs();
      const doc = docToSignRes.data.records[0];

      const signatureObject = {
        pin: password,
        signature: {
          id: doc.signaturedata.id,
          positions: doc.signaturedata.positions,
        },
        document: modifiedFile, // <--- Usamos el archivo modificado
      };

      const signDoc = await signDocument(signatureObject);

      if (!signDoc || !signDoc.data?.result) {
        Globals.showError('Credenciales incorrectas o error al firmar.');
        return; // Importante detener la ejecución si falla
      }

      const mimeType = 'application/pdf';
      const fileName = modifiedFile.name;

      // Convertimos el resultado de la firma a File
      const pdfFile = base64ToFile(signDoc.data.result, fileName, mimeType);

      // --- PASO C: Guardar el documento final ---
      await SignatureService.save({
        hasFile: true,
        ...state.form,
        user_id: user?.id,
        file: pdfFile,
      });

      Globals.showSuccess('Se ha enviado su documento');

      // Limpieza de estados
      setFile(null);
      setPassword('');
      setOpenGenerateForm(false);
      setState(null);
      setUser(null);
      setItem(null);
    } catch (error) {
      console.error('Error en sendResponse:', error);
      Globals.showError('Error al procesar el documento.');
    }
  };

  const openModal = (item: any, state: any, user: any) => {
    setOpenGenerateForm(true);
    setState(state);
    setUser(user);
    setItem(item);
  };

  const closeModal = () => {
    setOpenGenerateForm(false);
    setState(null);
    setUser(null);
    setItem(null);
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  useEffect(() => {
    init();
  }, []);
  return (
    <>
      <Signatures
        {...props}
        setLoading={setLoading}
        addSigner={addSigner}
        getDocs={getDocs}
        signDocument={signDocument}
        isExistCertificate={isExist}
        apacuana={apacuanaContext}
        file={file}
        password={password}
        sendResponse={sendResponse}
        openGenerateForm={openGenerateForm}
        setOpenGenerateForm={openModal}
      />
      {openGenerateForm && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Clave de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => closeModal()}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>

              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Debe ingresar la contraseña con la cual generó su certificado para proceder a
                    firmar
                  </p>
                  <div>
                    <div style={{ marginBottom: 12 }}>
                      <input
                        type='file'
                        onChange={(e: any) => setFile(e.target.files[0])}
                        accept='application/pdf'
                      />
                    </div>
                    <div className='col-md-12' style={{ padding: 0 }}>
                      <Input
                        maxLength={12}
                        type='password'
                        color='white'
                        name='phone_10'
                        label='Contraseña'
                        onChange={(e: any) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <button
                    style={{
                      width: '100%',
                      backgroundColor: '#0777FF !important',
                      color: '#fff',
                    }}
                    type='button'
                    disabled={password.length < 8}
                    className={`btn btn-report ${'active'}`}
                    onClick={() => sendResponse(item, state, user)}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ── Pestaña "Solicitudes pendientes de firma" (feature invitar firmantes, LT-305) ──
// Idéntico al de screens/client/signatures/signatures.tsx: reutiliza el mismo
// mecanismo de Apacuana (addSigner + getDocsByCustomer + signDocument sobre el
// certificado ya existente en el dispositivo) para firmar el documento del
// solicitante, y reporta el resultado al backend con reportSigned. Es agnóstico
// de rol -- funciona igual para un abogado invitado (código "A-45") que para un
// cliente (código "U-123").
const pendingBase64ToFile = (base64Data: string, filename: string, mimeType: string): File => {
  const base64Content = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
  const byteCharacters = atob(base64Content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new File([new Blob([byteArray], { type: mimeType })], filename, { type: mimeType });
};

const PendingSignatures = ({ user }: { user: any }) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState<any[]>([]);
  const [signingItem, setSigningItem] = useState<any>(null);
  const [password, setPassword] = useState('');

  const load = async () => {
    try {
      const res: any = await SignatureService.getPendingRequests({
        user_id: user?.id,
        withoutLoading: true,
      });
      setRequests(res.requests || []);
    } catch (error) {
      console.error('Error al cargar solicitudes pendientes de firma:', error);
    }
  };

  // Descarga el documento original (subido por el solicitante) como File,
  // igual que lo hace la vista de admin para poder re-adjuntarlo a Apacuana.
  const getDocumentFile = async (signature: any) => {
    const url = Constants.BASE_STORAGE + signature.file;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('No se pudo descargar el documento a firmar.');
    }
    const blob = await response.blob();
    const mimeType = response.headers.get('Content-Type') || 'application/pdf';
    const fileName = (signature.file || 'documento.pdf').split('/').pop();
    return new File([blob], fileName, { type: mimeType });
  };

  const sign = async () => {
    if (!signingItem) return;
    if (password.length < 8) {
      Globals.showError('Debe ingresar su contraseña de certificado electrónico.');
      return;
    }

    setLoading(true);
    try {
      const originalFile = await getDocumentFile(signingItem.signature);

      // --- Añadir hoja en blanco al PDF, mismo procedimiento que modal-create ---
      const existingPdfBytes = await originalFile.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.addPage();
      const pageCount = pdfDoc.getPageCount();
      const modifiedPdfBytes: any = await pdfDoc.save();
      const modifiedFile = new File([new Blob([modifiedPdfBytes])], originalFile.name, {
        type: 'application/pdf',
      });

      const fullDocument = apacuanaContext?.user?.full_document ?? '';
      const [typedoc, doc] = fullDocument.split('-');
      if (!typedoc || !doc) {
        Globals.showError('No se pudo leer su documento de identidad. Por favor contacte soporte.');
        return;
      }

      const signerData = {
        name: modifiedFile.name,
        reference: '',
        typedoc,
        doc,
        signature: [{ page: pageCount, x: 0.2, y: 0.7 }],
        file: modifiedFile,
      };

      await apacuanaContext?.sdk?.addSigner(signerData);

      const docToSignRes: any = await apacuanaContext?.sdk?.getDocsByCustomer({ page: 0, size: 1 });
      const preparedDoc = docToSignRes?.data?.records?.[0];
      if (!preparedDoc) {
        throw new Error('No se encontró el documento preparado para firmar.');
      }

      const signDoc: any = await apacuanaContext?.sdk?.signDocument({
        pin: password,
        signature: {
          id: preparedDoc.signaturedata.id,
          positions: preparedDoc.signaturedata.positions,
        },
        document: modifiedFile,
      });

      if (!signDoc || !signDoc.data?.result) {
        throw new Error('Credenciales incorrectas o error en el servidor de firma.');
      }

      await SignatureService.reportSigned({
        signature_signer_id: signingItem.id,
        apacuana_reference: String(preparedDoc.signaturedata.id),
      });

      Globals.showSuccess('Ha firmado el documento correctamente.');
      setSigningItem(null);
      setPassword('');
      load();
    } catch (error: any) {
      console.error('Error al firmar documento:', error);
      Globals.showError(error.message || 'Error al firmar el documento.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  useEffect(() => {
    load();
  }, []);

  // Todos los involucrados en el documento (dueño + resto de los invitados),
  // excluyendo siempre a quien está viendo la tarjeta.
  const getParticipants = (req: any) => {
    const all = [req.signature?.user, ...(req.signature?.signers || []).map((s: any) => s.user)];
    const seen = new Set<number>();
    return all.filter((u: any) => {
      if (!u || u.id === user?.id || seen.has(u.id)) return false;
      seen.add(u.id);
      return true;
    });
  };

  return (
    <>
      <Table title='' data={requests.length} header={['', '', '']}>
        {requests.map((req: any) => {
          const participants = getParticipants(req);
          return (
            <tr key={req.id}>
              <td style={{ width: '50%' }}>
                <div className='container-date'>
                  <div className='date'>
                    <p>{moment(req.signature?.created_at).format('DD/MM/YYYY')}</p>
                  </div>
                  <div className='code'>
                    <p>ID {req.signature?.number}</p>
                  </div>
                </div>
                <div className='container-lawyer'>
                  <img
                    src={
                      req.inviter?.photo ? Constants.BASE_STORAGE + req.inviter.photo : WhiteImage
                    }
                  />
                  <div className='container-name'>
                    <p>
                      <span className='bold'>
                        {req.inviter ? `${req.inviter.name} ${req.inviter.lastname}` : 'Un usuario'}
                      </span>{' '}
                      te invitó a firmar
                    </p>
                  </div>
                </div>
                <p className='text-secondary' style={{ fontSize: 13, margin: 0 }}>
                  <strong>Participantes: </strong>
                  {participants.length
                    ? participants
                        .map((p: any) => `${p.name || ''} ${p.lastname || ''}`.trim())
                        .join(', ')
                    : 'Sin otros participantes'}
                </p>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div
                  className='container-status'
                  style={{ backgroundColor: Colors.orange, width: 150 }}
                >
                  <p>Pendiente de firma</p>
                </div>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div className='container-files' style={{ flexWrap: 'nowrap' }}>
                  <button
                    type='button'
                    className={`file ${!req.signature?.file ? 'disabled' : ''}`}
                    disabled={!req.signature?.file}
                    style={{ margin: 0 }}
                    onClick={() =>
                      req.signature?.file && StorageService.openFile(req.signature.file)
                    }
                  >
                    <img src={ViewIcon} />
                    <div style={{ flex: 1 }}>
                      <p>Ver documento</p>
                    </div>
                  </button>
                </div>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div className='container-files' style={{ flexWrap: 'nowrap' }}>
                  <button
                    type='button'
                    className='container-add-table'
                    style={{
                      margin: 0,
                      padding: '0 10px',
                      height: '26.33px',
                      boxSizing: 'border-box',
                    }}
                    onClick={() => setSigningItem(req)}
                  >
                    <p style={{ padding: 0, margin: 0 }}>Firmar</p>
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
      </Table>

      {signingItem && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Clave de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => {
                    setSigningItem(null);
                    setPassword('');
                  }}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>
              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Debe ingresar la contraseña con la cual generó su certificado para proceder a
                    firmar
                  </p>
                  <Input
                    maxLength={12}
                    type='password'
                    color='white'
                    name='password'
                    label='Contraseña'
                    value={password}
                    onChange={(e: any) => setPassword(e.target.value)}
                  />
                  <button
                    style={{ width: '100%', backgroundColor: '#0777FF !important', color: '#fff' }}
                    type='button'
                    disabled={password.length < 8}
                    className='btn btn-report active'
                    onClick={sign}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(SignaturesWithApacuana);
